(function() {

  angular
	.module('meanApp')
	.controller('usersCtrl', usersCtrl);

  usersCtrl.$inject = ['$location', 'usersManager', '$rootScope', 'alert'];
  function usersCtrl($location, usersManager, $rootScope, alert) {
	var vm = this;
	//console.log('the current user is ', $rootScope.currentUser);
	vm.users = {};
	vm.filters = {};
	vm.totalPages = 0;
	vm.totalUsers = 0;
	vm.currentPage = 1;

	$rootScope.$watch('currentUser', function () {
		if ($rootScope.currentUser) {
			if($rootScope.currentUser.role === 'admin'){
				loadProfiles();
			}
			else {
				$location.path('/');
			}
		}
	}, function(err){
		console.log(err);
	});

	var loadProfiles = function () {
	  usersManager.getAllUsers(vm.currentPage, vm.filters)
	  .then(function(result) {
		console.log('users', result)
		vm.users = result.collection;
		vm.totalPages = result.pages;
		vm.totalUsers = result.total;
		console.log(vm.users[0].getInitials());
	  }, function(err) {
		console.log('erreur loading all profiles');
		console.log(err);
	  });
	};

	vm.pageChanged = function () {
	  loadProfiles();
	};

	vm.toggleRoleFilter = function (filter) {
		if (filter) {
			vm.filters.role = filter;
			loadProfiles();
		}
	};

	vm.toggleProviderFilter = function (filter) {
		if (filter) {
			vm.filters.provider = filter;
			loadProfiles();
		}
	};

	vm.toggleActivationFilter = function(filter) {
		if (filter) {
			vm.filters.active = filter;
			loadProfiles();
		}	
	};

	vm.removeUser= function (userId) {
		usersManager.delete(userId)
		.then(function() {
	  		alert.push('success', 'Cet utilisateur a été supprimé définitivement de la base de données');
			//loadProfiles();
	  	}, function() {
	  		alert.push('danger', "Cet utilisateur n'a pas pu être supprimé");
	  	});
	};

	vm.onEmailSubmit = function() {
		if (vm.email) {
			var newAuthorUser = usersManager.set({
				email: vm.email,
				role: 'author'
			});
			newAuthorUser.save()
			.then(function (user) {
				alert.push('success', 'Nouvel utililisateur ajouté en base de données');
			}, function (error) {
				//TOOD préciser si déja en base de données ou quoi
				alert.push('danger', 'Utilisateur non ajouté en base de données, car erreur');
			});
		}
	};

	vm.availableOptions = [
		{id: 'member', name: 'Membre'},
      	{id: 'author', name: 'Auteur'},
      	{id: 'admin', name: 'Administrateur', disabled : true}	
	];

	vm.onChangeRole = function() {
		//conditions : 
		//1- user that is admin cant have another role
		//2- no user can become admin through this interface

		//at least option has changed
		if (vm.selectedOption.id !== vm.searchUser.role) {
			vm.searchUser.update({
				role : vm.selectedOption.id
			})
			.then(function (user) {
				alert.push('success', 'Le role a bien ete changé');
			}, function (error) {
				//TOOD préciser si déja en base de données ou quoi
				alert.push('danger', 'role non changé, une erreur est survenue');
			});
		}
	};

	vm.onSearchUserSubmit = function() {
		if (vm.emailSearch) {
			usersManager.searchUserByEmail(vm.emailSearch)
			.then(function(user) {
				vm.searchUser = user;
				vm.selectedOption = { id : vm.searchUser.role};
			}, function(err) {
				console.log('erreur searching the profile');
				console.log(err);
			});
		}
	};
	
  }

})();